module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-en6.4a666a2.png";